module.exports = __webpack_public_path__ + "static/media/PortugalGetaways.0c575ad2.ico";